import { render } from "./CmsHeader.vue?vue&type=template&id=16dc2442&scoped=true&ts=true"
import script from "./CmsHeader.vue?vue&type=script&lang=ts"
export * from "./CmsHeader.vue?vue&type=script&lang=ts"

import "./CmsHeader.vue?vue&type=style&index=0&id=16dc2442&scoped=true&lang=css"

import exportComponent from "C:\\Users\\cpinkney\\Documents\\Dev\\GroupTrips3\\grouptrips-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16dc2442"]])

export default __exports__